export default [
  {
    path: '/budgetplan/:key?',
    name: 'budgetplan',
    component: () => import('@/views/budgetPlan/BUPlanReceiptIndex.vue'),
    meta: {},
  },
  {
    path: '/budgetplan/templatereceipt/tt342',
    name: 'templatereceipttt342',
    component: () => import('@/views/budgetPlan/planTemplateReceipt/TT342/BUPlanTemplateReceiptTT342List.vue'),
    meta: {},
  },
  {
    path: '/budgetplan/templatereceipt/tt343',
    name: 'templatereceipttt343',
    component: () => import('@/views/budgetPlan/planTemplateReceipt/TT343_344/BUPlanTemplateReceiptTT343_344List.vue'),
    meta: {},
  },
  {
    path: '/budgetplan/templateexpense/tt342',
    name: 'templateexpensett342',
    component: () => import('@/views/budgetPlan/planTemplateExpense/TT342/BUPlanTemplateExpenseTT342List.vue'),
    meta: {},
  },
  {
    path: '/budgetplan/templateexpense/tt343',
    name: 'templateexpensett343',
    component: () => import('@/views/budgetPlan/planTemplateExpense/TT343_344/BUPlanTemplateExpenseTT343_344List.vue'),
    meta: {},
  },
];
